<template>
	<ListPage :query="query" :total="total" row-key="id" v-loading="loading" :data="tableData"
		@size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery"
		:pager="!!query.keywords">
		<template slot="filters">
			<el-form-item label="菜单名称" prop="keywords">
				<el-input v-model="query.keywords" placeholder="请输入菜单名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="菜单名称" align="left" prop="name" />
			<el-table-column label="路由地址" align="center" prop="uri" />
			<el-table-column label="排序号" align="center" prop="sortNo" />
			<el-table-column label="创建时间" align="center" prop="createTime" />
			<el-table-column label="操作" align="center" width="200">
				<template slot-scope="{ row }">
					<div class="actions">
						<el-link :underline="false" type="primary" @click="handleEdit(row)">
							编辑
						</el-link>
						<el-link v-if="row.menuType < 2" :underline="false" type="primary" @click="handleAddChild(row)">
							添加子菜单
						</el-link>
						<el-link :underline="false" type="danger" @click="handleDel(row)">
							删除
						</el-link>
					</div>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, del, list } from "@/api/permission/menu";
import listMixin from '@/mixins/list';

export default {
	data() {
		return {
			// 查询参数
			query: {
				keywords: ""
			},
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			if (this.query.keywords) {
				page(this.query).then(({ code, result, message }) => {
					if (code == 200) {
						this.tableData = result.records;
						this.total = result.total;
					} else {
						this.$message.error(message);
					}
					this.loading = false;
				})
			} else {
				list().then(({ code, result, message }) => {
					if (code == 200) {
						this.tableData = result;
						this.total = result.length;
					} else {
						this.$message.error(message);
					}
					this.loading = false;
				});
			}
		},
		handleAdd() {
			this.$router.push("/permission/menu/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/menu/form", query: { id: row.id } });
		},
		handleAddChild(row) {
			this.$router.push({ path: "/permission/menu/form", query: { pid: row.id, menuType: row.menuType } });
		},
		handleDel(row) {
			this.$confirm("是否删除该菜单?", "提示", {
				type: "warning",
			})
				.then(() => {
					del({ id: row.id }).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>